import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { selectTopBetsSerpUrl } from '../../../../selectors/topBets';
import { BetLeadersTitle } from './BetLeadersTitle';
import { trackSerpLinkClick } from './BetLeadersTitle.tracking';

export const BetLeadersTitleContainer = () => {
  const isMobile = useIsMobileDevice();

  const serpUrl = useSelector(selectTopBetsSerpUrl) || undefined;

  return <BetLeadersTitle isMobile={isMobile} serpUrl={serpUrl} onLinkClick={trackSerpLinkClick} />;
};
